/**
 * The password-reset token, taken out of the address bar (DPDP Phase 13).
 *
 * A reset link left in the URL ends up in the browser history, in a
 * screenshot, and - for a same-origin request - in the Referer header: each
 * a working password reset for whoever finds it. The page reads it once and
 * replaces the URL with the bare path; the token lives on only in memory,
 * for the one request that needs it.
 */
export function takeResetToken(
  location: Pick<Location, 'search' | 'pathname' | 'hash'>,
  history: Pick<History, 'replaceState' | 'state'>,
): string {
  const params = new URLSearchParams(location.search);
  const token = params.get('token') ?? '';
  if (params.has('token')) {
    params.delete('token');
    const rest = params.toString();
    history.replaceState(history.state, '', `${location.pathname}${rest ? `?${rest}` : ''}${location.hash}`);
  }
  return token;
}
